// Shared constants and data for the brochure pages.

export const PHONE_DISPLAY = "+91 86181 96685";
export const PHONE_TEL = "+918618196685";
export const WHATSAPP_NUMBER = "918618196685"; // E.164 minus '+'
export const WHATSAPP_MESSAGE =
  "Hi INPACE POWER, I just viewed your brochure and would like to discuss a solar rooftop solution.";
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

export const HERO_IMG =
  "https://images.unsplash.com/photo-1635424709870-cdc6e64f0e20?crop=entropy&cs=srgb&fm=jpg&q=85";

export const SERVICES = [
  {
    title: "Rooftop Selection Criteria",
    tag: "Engineering Survey",
    desc:
      "We evaluate RCC, asbestos or sheet-metal roofs for orientation, shadow-free area and structural load — engineered for maximum yield.",
    img: "https://images.unsplash.com/photo-1635424709845-3a85ad5e1f5e?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    title: "Solar Panel Maintenance",
    tag: "AMC & Monitoring",
    desc:
      "Annual maintenance contracts, panel cleaning, inverter health checks and remote monitoring to preserve peak efficiency year-round.",
    img: "https://images.unsplash.com/photo-1660330589505-9a433a742a7b?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    title: "CAPEX Model",
    tag: "Capital Ownership",
    desc:
      "Own your plant outright — best returns, accelerated depreciation and full ownership of every unit of power generated on your roof.",
    img: "https://images.unsplash.com/photo-1542336391-ae2936d8efe4?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    title: "OPEX / RESCO Model",
    tag: "Zero Investment",
    desc:
      "Zero capital investment — pay only for the units consumed under a long-term Power Purchase Agreement with INPACE POWER.",
    img: "https://images.unsplash.com/photo-1559302504-64aae6ca6b6d?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    title: "On-Grid Systems",
    tag: "Net-Metering Ready",
    desc:
      "Grid-tied inverters with BESCOM net-metering — surplus power is exported, billed and credited automatically to your utility account.",
    img: "https://images.unsplash.com/photo-1660330589257-813305a4a383?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    title: "Off-Grid & Hybrid",
    tag: "Battery Backed",
    desc:
      "Battery-backed systems for uninterrupted power in remote sites and load-shedding zones — independence from the grid, by design.",
    img: "https://images.unsplash.com/photo-1660330589243-4c640d878052?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
];

export const BENEFITS = [
  { num: "01", title: "Non-Polluting", desc: "Zero emissions during power generation — a clean source for your home and business operations." },
  { num: "02", title: "Easy Installation", desc: "Most rooftops are commissioned in under 7 days with minimal civil work and disruption." },
  { num: "03", title: "Renewable Energy", desc: "Limitless sunlight converted into usable electricity all day, every day, year after year." },
  { num: "04", title: "Clean & Green", desc: "A tonne of CO₂ avoided every year for every 1 kW you install on your rooftop." },
  { num: "05", title: "Solar Maintenance", desc: "Annual maintenance contracts that keep your system at peak efficiency, season after season." },
  { num: "06", title: "Easy Financing", desc: "EMI options, CAPEX and OPEX models tailored for every budget, residential to industrial." },
];

export const SECTORS = [
  {
    title: "Residential Sector",
    count: "224",
    metric: "Installations",
    desc: "Homes powered across Bangalore and surrounding areas — from independent villas to high-rise societies.",
    region: "Across Karnataka",
    img: "https://images.unsplash.com/flagged/photo-1566838616631-f2618f74a6a2?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    title: "Commercial Sector",
    count: "10",
    metric: "Projects",
    desc: "Offices, showrooms and retail spaces running on rooftop solar — strong ROI within payback windows.",
    region: "Across Karnataka",
    img: "https://images.unsplash.com/photo-1583345237708-add35a664d77?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    title: "Industrial Sector",
    count: "08",
    metric: "Plants · 200 kW+",
    desc: "Large-scale factory rooftops, each above 200 kW capacity — engineered for heavy industrial loads.",
    region: "Across Karnataka",
    img: "https://images.unsplash.com/photo-1726866492047-7f9516558c6e?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
];

export const STEPS = [
  { n: "01", title: "Site Survey", desc: "Complimentary rooftop survey, shadow-analysis report and load assessment, performed by our certified engineers." },
  { n: "02", title: "Custom Design", desc: "Engineered single-line diagrams, detailed BOQ and twenty-five-year ROI projections — transparent, no hidden costs." },
  { n: "03", title: "Installation", desc: "Certified in-house crews complete installation, mounting, wiring and inverter setup in under seven working days." },
  { n: "04", title: "Net-Metering", desc: "We handle all BESCOM applications, approvals and commissioning end-to-end so you start saving from day one." },
];

export const TOC = [
  { num: "I", name: "About Inpace Power", sub: "Company History, Mission & Vision", pg: "04" },
  { num: "II", name: "Why Solar", sub: "Six Pillars of Renewable Value", pg: "06" },
  { num: "III", name: "Sectors We Serve", sub: "Residential, Commercial, Industrial", pg: "08" },
  { num: "IV", name: "Solar Solutions", sub: "Six Engineered Services", pg: "10" },
  { num: "V", name: "How We Power Your Rooftop", sub: "Our Four-Step Process", pg: "12" },
  { num: "VI", name: "Voices of Our Clients", sub: "Testimonials & Why Choose Us", pg: "14" },
  { num: "VII", name: "Get In Touch", sub: "Consultation & Contact", pg: "16" },
];
